import { useContextState } from "../../../../../../../../hooks/theme"

const useFolioAmountStyles = () => {
    const { colors } = useContextState()
    return {
        containerFolioAmount: {
            display: 'flex',
            columnGap: '10px',
            alignItems: 'center',
        },
        containerFolio: {
            display: 'flex',
            flexDirection: 'column',
            columnGap: '10px',
            justifyContent: 'center',
        },
        tracking: {
            fontSize: '12px',
            fontStyle: 'italic',
            color: colors.color10,
            width: '100%',
        },
        foliosAmount: {
            maxWidth: '115px',
            fontSize: '14px',
            color: colors.color9,
            fontWeight: '600',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
        },
    }
}

export { useFolioAmountStyles }